import {
  checkErrors,
  getEmptyContent
} from '@com-delta-idp/mnx-skymiles-shared';
import { DisplayProperties } from '@com-delta-omnichannel/aura';
import { ErrorMessages } from '../models/error-messages.constants';

export const getFullPageError = (
  errors: (string | undefined)[]
): DisplayProperties => {
  if (checkErrors(errors, ErrorMessages)) {
    return getEmptyContent<DisplayProperties>('full-page', ErrorMessages, true);
  }
  return getEmptyContent<DisplayProperties>();
};
